import QABlock from './QABlock';

export default QABlock;
